export const closeWindow = () => {
  window.close();
};
